module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai678-ef8ff119c998db2e52ea8704e96f906d.jpg";